import Button from "@mui/material/Button"
import { styled } from "@mui/material/styles"

export const StyledButton = styled(Button)(({ theme }) => ({
  paddingInline: theme.spacing(1.5),
  paddingBlock: theme.spacing(1),
}))
